
import { Component, Vue } from 'vue-property-decorator';

@Component<LetterFooterComponent>({})
export default class LetterFooterComponent extends Vue {}
